<template>
  <div class="font-QuestrialFont">
    <p class="text-center mb-2">Are you sure?</p>
    <div>
      <ul class="flex space-x-3 justify-center">
        <li
          class="hover:bg-gray-200 list-item-style"
          @click="$emit('cancelDelete')"
        >
          Cancel
        </li>
        <li
          class="list-item-style text-white bg-red-500"
          @click="$emit('deleteHandler')"
        >
          Yes, Delete
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "DeleteConfirmation",
};
</script>

<style scoped>
.list-item-style {
  @apply px-4 py-2 border rounded cursor-pointer;
}
</style>